import React from 'react';
import Relay from 'react-relay/classic';
import PropTypes from 'prop-types';
import { SecondaryButton } from 'dibs-elements';
import get from 'lodash.get';
import qs from 'qs';
import pdpDisplayHelper from 'dibs-display-helpers/dist/pdpDisplayHelper';

import provideContext from 'fluxible-addons-react/provideContext';
import connectToStores from 'fluxible-addons-react/connectToStores';

import ItemStore from '../../stores/ItemStore.es';

import 'dibs-elements/dist/Button/buyer/Secondary.css';

import MakeOfferButton from '../../../components/ItemActionButtons/MakeOfferButton/MakeOfferButton';
import styles from './contactDealerSidebar.scss';

let queryString = global.location.search;
queryString = queryString.substr(1, queryString.length);

const emailTmplName = get(qs.parse(queryString), 'e_tmpl') || '';

function ContactDealerSidebar(props) {
    const {
        copy = {},
        item,
        isCustomizable,
        user,
        onClick,
        canonicalUrl,
        url,
        itemEligibleForProcurement,
    } = props;

    const buyerHasTradePermission = get(user, 'canUseNetPrice');
    const buyerId = get(user, 'serviceId');

    const { showMakeOfferCTA } = pdpDisplayHelper({
        item: item.toJSON ? item.toJSON() : item,
        buyerId,
        buyerHasTradePermission,
    }).getShowCTAs();

    const isVerifiedTrade = get(user, 'isVerifiedTrade');
    const isOutsideSales = get(user, 'tradeFirm.isOutsideSales');
    const cta = isCustomizable ? copy.customizeItem : copy.askTheDealer;
    const title = copy.qAboutThisPiece;
    const dataTn = isCustomizable
        ? 'contact-dealer-customize-sidebar-button'
        : 'contact-dealer-ask-sidebar-button';

    return (
        <div className="contact-dealer-sidebar-wrapper">
            {title && <div className={styles.title}>{title}</div>}
            <SecondaryButton
                className={styles.button}
                dataTn={dataTn}
                onClick={onClick}
                size="small"
            >
                {cta}
            </SecondaryButton>
            {/*
                Given that "Make Offer" CTA (showMakeOfferCTA) is true, it should be displayed here if both:
                1) item IS Furniture/Art (itemEligibleForProcurement) and
                2) user/trade firm IS Tier 1/Tier 2 (isOutsideSales)
                Otherwise, is should be displayed in middle section of sidebar (see ItemCTAButtons.jsx)
            */}
            {showMakeOfferCTA &&
                isVerifiedTrade &&
                isOutsideSales &&
                itemEligibleForProcurement && (
                    <MakeOfferButton
                        buttonClass={`${styles.button} button-small`}
                        currency={get(user, 'profile.currency')}
                        tracking={{
                            pageContext: 'pdp',
                            url: canonicalUrl || url,
                            emailTmplName,
                        }}
                        item={item}
                    />
                )}
        </div>
    );
}

ContactDealerSidebar.propTypes = {
    onClick: PropTypes.func.isRequired,
    isCustomizable: PropTypes.bool,
    copy: PropTypes.shape({
        qAboutThisPiece: PropTypes.string,
        qAboutThisItem: PropTypes.string,
        askTheDealer: PropTypes.string,
        customizeItem: PropTypes.string,
        contactUs: PropTypes.string,
        contactUsDescription: PropTypes.string,
    }),
    item: PropTypes.object.isRequired,
    itemEligibleForProcurement: PropTypes.bool.isRequired,
    user: PropTypes.shape({
        serviceId: PropTypes.string,
        canUseNetPrice: PropTypes.bool,
    }),
    context: PropTypes.object,
    canonicalUrl: PropTypes.string,
    url: PropTypes.string,
};

module.exports = Relay.createContainer(
    provideContext(
        connectToStores(ContactDealerSidebar, [ItemStore], context => {
            const itemStore = context.getStore(ItemStore);
            const item = itemStore.getItem();

            return {
                item,
                canonicalUrl: itemStore.getFromSV('data.canonicalUrl'),
                url: itemStore.getUrl(),
            };
        })
    ),
    {
        fragments: {
            user: () => Relay.QL`
            fragment on User {
                serviceId
                canUseNetPrice
                isVerifiedTrade
                tradeFirm {
                    isOutsideSales
                }
                profile {
                    currency
                }
            }
        `,
        },
    }
);



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/ContactDealer/ContactDealerSidebar.jsx